module.exports = __webpack_public_path__ + "static/img/achievements.8111a8a.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/achievements.png
// module id = tg1C
// module chunks = 1